document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.button');
  buttons.forEach((button) => {
    button.addEventListener('pointerdown', () => button.style.transform = 'translateY(1px) scale(.99)');
    button.addEventListener('pointerup', () => button.style.transform = '');
    button.addEventListener('pointerleave', () => button.style.transform = '');
  });
});
